import React from 'react'
import { Button, Element, Icon } from 'react-bulma-components'
import { useModal } from '../../modal'
import { QrcodeIcon } from '@heroicons/react/outline'
import { User } from '../../../api/users'
import UserQrCodeModal from '../modals/user-qr-code'
import { ButtonProps } from '../../../types/bulma'

interface ShowQrCodeButtonProps {
  user: User
  canRegenerate?: boolean
  color?: ButtonProps['color']
  label?: string
  isExternalWorker?: boolean
}

const ShowQrCodeButton: React.FC<ShowQrCodeButtonProps> = ({
  user,
  canRegenerate = true,
  color = 'default',
  label,
  isExternalWorker = false,
}) => {
  const modal = useModal()
  return (
    <>
      <Button
        size="small"
        onClick={() => {
          modal.setIsDisplayed(true)
        }}
        data-test={`show-qr-code-${user._id}`}
        color={color}
      >
        <Icon>
          <QrcodeIcon />
        </Icon>
        {label && <Element renderAs="span">{label}</Element>}
      </Button>
      <UserQrCodeModal
        modalActions={modal}
        user={user}
        canRegenerate={canRegenerate}
        isExternalWorker={isExternalWorker}
      />
    </>
  )
}

export default ShowQrCodeButton
